import { defineSlotRecipe } from "@chakra-ui/react";

import { checkMarkRecipe, legacyCheckmarkRecipe } from "./CheckMark";

export const checkboxSlotRecipe = defineSlotRecipe({
  slots: ["root", "control", "label", "indicator"],
  className: "chakra-checkbox",
  base: {
    root: {
      alignItems: "start",
    },
    control: checkMarkRecipe.base,
    indicator: {},
    label: {
      verticalAlign: "middle",
      fontWeight: "normal",
      fontFamily: "Inter, sans-serif",
      color: "text.soft",
      _hover: {
        cursor: "pointer",
      },
      _disabled: {
        color: "text.soft",
      },
    },
  },
  variants: {
    variant: {
      outline: {
        control: checkMarkRecipe.variants?.variant.outline,
      },
      mpXlStyle: {
        root: {},
        control: legacyCheckmarkRecipe.variants?.variant.mpXlStyleMark,
      },
    },
    size: {
      sm: {
        control: legacyCheckmarkRecipe.variants?.size?.sm,
      },
      md: {
        label: {
          fontSize: "14px",
          mt: "-1px",
        },
      },
      lg: {
        control: checkMarkRecipe.variants?.size?.lg,
      },
      xl: {},
    },
  },
  defaultVariants: {
    variant: "mpXlStyle",
  },
});

export default checkboxSlotRecipe;
